import React from 'react';
import { VetProfileAvatar, VetProfileAvatarProps } from './VetProfileAvatar';
import { VetProfileCard } from './VetProfileCard';
import { VetProfileCardName } from './VetProfileCardName';
import { VetProfileCardDegree } from './VetProfileCardDegree';
import { VetProfileCardSpecializationText } from './VetProfileCardSpecializationText';
import { BoxProps } from '../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../wag-react/next-components/Flex';
type VetProfileValue = Pick<VetProfileAvatarProps, 'src'> & {
  name: string;
  degree: string;
  specializationText: string;
};
export type VetProfileProps = Omit<BoxProps, 'value'> & {
  value: VetProfileValue;
};
export const VetProfile = ({
  value: {
    name,
    src,
    degree,
    specializationText
  },
  ...rest
}: VetProfileProps) => <VetProfileCard {...rest} data-sentry-element="VetProfileCard" data-sentry-component="VetProfile" data-sentry-source-file="VetProfile.tsx">
    <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="VetProfile.tsx">
      <Flex mr="20px" data-sentry-element="Flex" data-sentry-source-file="VetProfile.tsx">
        <VetProfileAvatar src={src} data-sentry-element="VetProfileAvatar" data-sentry-source-file="VetProfile.tsx" />
      </Flex>
      <Flex flexDirection="column" data-sentry-element="Flex" data-sentry-source-file="VetProfile.tsx">
        <VetProfileCardName data-sentry-element="VetProfileCardName" data-sentry-source-file="VetProfile.tsx">
          {name}
        </VetProfileCardName>
        <VetProfileCardDegree data-sentry-element="VetProfileCardDegree" data-sentry-source-file="VetProfile.tsx">
          {degree}
        </VetProfileCardDegree>
      </Flex>
    </Flex>

    <VetProfileCardSpecializationText data-sentry-element="VetProfileCardSpecializationText" data-sentry-source-file="VetProfile.tsx">
      {specializationText}
    </VetProfileCardSpecializationText>
  </VetProfileCard>;